export default __webpack_public_path__ + "static/media/probes3.22ba0bbd.jpg";